import { JobCandidatesCompareComponent } from "./job-candidates-compare.component";
export var JobCandidatesCompareModule = angular
    .module('jobCandidatesCompare', [])
    .component(JobCandidatesCompareComponent.selector, JobCandidatesCompareComponent.component)
    .name;
//# sourceMappingURL=job-candidates-compare.module.js.map